import { render, staticRenderFns } from "./TableCellCommentIcon.vue?vue&type=template&id=e4f95cfa&"
import script from "./TableCellCommentIcon.vue?vue&type=script&lang=ts&"
export * from "./TableCellCommentIcon.vue?vue&type=script&lang=ts&"
import style0 from "./TableCellCommentIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports